import { render, staticRenderFns } from "./TeamList.vue?vue&type=template&id=c5bdfb52&scoped=true&"
import script from "./TeamList.vue?vue&type=script&lang=js&"
export * from "./TeamList.vue?vue&type=script&lang=js&"
import style0 from "./TeamList.vue?vue&type=style&index=0&id=c5bdfb52&lang=scss&scoped=true&"
import style1 from "./TeamList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5bdfb52",
  null
  
)

export default component.exports